export default {
  SET_ITEMS(state, { items, total, totalAll, reset }) {
    state.items = reset ? items : [...state.items, ...items]
    state.total = typeof total === 'number' ? total : state.total
    if (typeof totalAll === 'number') {
      state.totalAll = totalAll
    }
  },

  SET_SEARCH(state, payload) {
    state.search = payload
  },

  SET_LOADING(state, status) {
    state.loading = status
  },

  SET_SORT(state, payload) {
    state.sort = payload
  },

  SET_PAGE(state, payload) {
    state.page = payload
  },

  RESET_PAGE(state) {
    state.items = []
    state.page = 1
    state.total = 0
  },

  RESET_SEARCH(state) {
    state.search = null
  },

  RESET_STORE(state, { resetSort = true, resetTotal = true } = {}) {
    state.items = []
    state.page = 1

    if (resetTotal) {
      state.total = 0
    }

    if (resetSort) {
      state.sort = {
        ...state.sort,
      }
    }
  },
}
